import { uniqBy } from "lodash";
import { useMemo } from "react";
import { RollupWithTagsAndCountsAndRange, TimeRangeFinite } from "types/types";
import { useGetPageFromPath } from "utils/customHooks/genericHooks";
import { useTrendChartBarsArray } from "utils/customHooks/trendChartHooks";

export const useRollupMetricForBarRange = (barRange: TimeRangeFinite) => {
  const { isTrendsPage } = useGetPageFromPath();
  const rollupMetricTrendChartBarsArray = useTrendChartBarsArray(isTrendsPage);

  const uniqRollups = useMemo(() => {
    return uniqBy(rollupMetricTrendChartBarsArray, ({ range }) => range.ge);
  }, [rollupMetricTrendChartBarsArray]);
  const rollupMetric = useMemo(() => {
    if (!barRange) {
      return null;
    }
    // find the data whose range overlaps (can't always match exactly due to custom timezone offset, midgard vs askr APIs, etc.)
    const match = uniqRollups.find(
      ({ range }) => range.ge <= barRange.ge && barRange.ge < range.lt
    );

    return match ?? null;
  }, [uniqRollups, barRange]);

  return rollupMetric ?? EMPTY_ROLLUP;
};

const EMPTY_ROLLUP: RollupWithTagsAndCountsAndRange = {
  counts: {
    producing: {},
    planned: {},
    unplanned: {},
    waiting: {},
    unknown: {},
    notScheduled: {},
    uncollected: {},
  },
  notScheduled: 0,
  planned: 0,
  producing: 0,
  totalDurationMs: 3600000,
  uncollected: 0,
  unknown: 0,
  unplanned: 0,
  waiting: 0,
  tags: {
    notScheduled: {},
    planned: {},
    producing: {},
    uncollected: {},
    unknown: {},
    unplanned: {},
    waiting: {},
  },
  range: {
    ge: 0,
    lt: 1,
  },
  qualityLoss: 0,
  netOutput: 0,
  grossOutput: 0,
  cumulativeOutput: 0,
};
